import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../services/redux/types";

export const selectMeetingState = (state: RootState) => state.meetingState;

export const selectMeetingValue = createSelector(
  selectMeetingState,
  (state) => state.meetingValue
);

export const selectMeetingMessages = createSelector(
  selectMeetingState,
  (state) => state.messages
);

export const selectMeetingSelectedAssistant = createSelector(
  selectMeetingState,
  (state) => state.selectedAssistant
);

export const selectRecognizeHash = createSelector(
  [selectMeetingValue],
  (meetingValue) => {
    return meetingValue?.meetings_object?.recognize_hash ?? null;
  }
);

export const selectFinalResult = createSelector(
  [selectMeetingValue],
  (meetingValue) => {
    return meetingValue?.meetings_object?.final_result ?? null;
  }
);

export const selectMeetingsThread = createSelector(
  [selectMeetingValue],
  (meetingValue) => {
    return meetingValue?.meetings_object?.thread_ref ?? null;
  }
);

export const selectEstimateDuration = createSelector(
  [selectMeetingValue],
  (meetingValue) => {
    return meetingValue?.meetings_object?.meta.estimate_duration ?? null;
  }
);

export const selectTranscriptionInfo = createSelector(
  [selectMeetingValue],
  (meetingValue) => {
    if (!meetingValue?.meetings_object) return;
    return meetingValue.meetings_object.meeting_info;
  }
);

export const selectSpeakers = createSelector(
  [selectMeetingValue],
  (meetingValue) => {
    return meetingValue?.meetings_object?.transcription ?? [];
  }
);

export const selectUniqueSpeakers = createSelector(
  [selectSpeakers],
  (transcription) => {
    return Array.from(
      new Map(
        transcription.map((item) => [
          item.speaker_group_key,
          {
            id: item.id,
            speaker_group_key: item.speaker_group_key,
            speaker_name: item.speaker_name,
            isActive: item.isActive,
            time_code: item.time_code,
          },
        ])
      ).values()
    );
  }
);

export const selectProgress = createSelector(
  [selectMeetingValue],
  (meetingValue) => {
    return meetingValue?.meetings_object?.meta.progress ?? null;
  }
);

export const selectSpeaker = createSelector(
  [selectMeetingValue, (_state: RootState, speakerId: string) => speakerId],
  (meetingValue, speakerId) => {
    return meetingValue?.meetings_object?.transcription?.find(
      (speaker) => speaker.id === speakerId
    );
  }
);

export const selectRecognizeMetaObject = createSelector(
  [selectMeetingState, (_state: RootState, id: string) => id],
  (state, id) => {
    return state.recognizeMeta[id] ? state.recognizeMeta[id] : null;
  }
);

export const selectIsMessageLoading = createSelector(
  selectMeetingState,
  (state) => state.isMessageLoading
);
